/*
 * @Author: your name
 * @Date: 2020-10-19 18:04:43
 * @LastEditTime: 2020-10-19 18:05:49
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /saas-consumer-platform/src/utils/sleep.js
 */

/**
 *  休眠一段时间
 * @param time
 * @returns {Promise<any>}
 */
export default function (time) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), time);
  });
}